import { useCallback, useEffect, useState } from 'react';

const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

export const useRecaptcha = () => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // Wait for reCAPTCHA to load
    const checkRecaptcha = setInterval(() => {
      if (window.grecaptcha && window.grecaptcha.ready) {
        window.grecaptcha.ready(() => {
          setIsReady(true);
        });
        clearInterval(checkRecaptcha);
      }
    }, 100);

    // Timeout after 10 seconds
    const timeout = setTimeout(() => {
      clearInterval(checkRecaptcha);
      console.warn('reCAPTCHA failed to load within 10 seconds');
    }, 10000);

    return () => {
      clearInterval(checkRecaptcha);
      clearTimeout(timeout);
    };
  }, []);

  const executeRecaptcha = useCallback(async (action) => {
    if (!SITE_KEY || SITE_KEY === 'YOUR_RECAPTCHA_SITE_KEY_HERE') {
      console.warn('reCAPTCHA site key not configured');
      return null;
    }

    // Wait for reCAPTCHA to be ready
    return new Promise((resolve, reject) => {
      const maxAttempts = 50; // 5 seconds max wait
      let attempts = 0;
      
      const checkAndExecute = () => {
        attempts++;
        
        if (window.grecaptcha && window.grecaptcha.execute) {
          window.grecaptcha.execute(SITE_KEY, { action })
            .then(resolve)
            .catch((err) => {
              console.error('reCAPTCHA execute error:', err);
              reject(err);
            });
        } else if (attempts < maxAttempts) {
          setTimeout(checkAndExecute, 100);
        } else {
          console.error('reCAPTCHA not available after waiting');
          reject(new Error('reCAPTCHA not available'));
        }
      };
      
      checkAndExecute();
    });
  }, []);

  const isConfigured = SITE_KEY && SITE_KEY !== 'YOUR_RECAPTCHA_SITE_KEY_HERE';

  return { executeRecaptcha, isConfigured, isReady };
};

export default useRecaptcha;
